import { SongData } from 'services/store/distribution/types';
import { toColonTimeFromMs } from 'services/helpers/time';
import {
  StyledListItem,
  StyledListItemContent,
  StyledTypography,
} from './styled';

type PropsType = {
  song: SongData;
};
const SongsListItem = ({ song }: PropsType) => (
  <StyledListItem>
    <StyledListItemContent>
      <StyledTypography>{song.title}</StyledTypography>
      <StyledTypography>{toColonTimeFromMs(song.duration)}</StyledTypography>
    </StyledListItemContent>
  </StyledListItem>
);

export default SongsListItem;
